import * as React from 'react'

import('./StatsNameStyles.scss')   



const StatsNamePresentation = (props:any) => {
  return (
    <div className="statisticNameWrapper">
      <div className="statisticName">
        <div className="statisticNameTitle">
          {props.headline}
        </div>
        <div className="statisticNameSubtitle">
          {props.subtitle}
        </div>
      </div>
    </div>
  )
}

export default StatsNamePresentation